/* eslint-disable indent */
/* eslint-disable operator-linebreak */
import { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { isEmpty, trim } from 'lodash';

import DataPreview from '../../common/dataPreview/DataPreview';
import { getLicenseDetails } from '../../../apis/cannabisLicenseApi';
import store from '../../../store/store';
import * as commonActions from '../../../store/actions/common';
import CannabisLicenseHelper from '../../../helpers/features/CannabisLicensesHelper';
import { getSource } from '../../../apis/sourcesApi';

function DetailsView({ selectedRowData = {} }) {
  const { id } = useParams();

  const [singleLicenseData, setSingleLicenseData] = useState({});
  const [optionalColumns, setOptionalColumns] = useState([]);

  const getSourceData = async uploadId => {
    // Fetch the single license data based on the ID
    try {
      const { data } = await getSource(uploadId);
      if (data && !isEmpty(data)) {
        let columnArray = data?.optional_columns?.split(',').map(val => trim(val)) ?? [];
        if (columnArray.length > 0 && data.country_code !== 'CA') {
          const columnsToRemove = ['lic-auth-patients', 'lic-auth-distributors'];
          columnArray = columnArray.filter(item => !columnsToRemove.includes(item));
        }
        setOptionalColumns(columnArray);
      }
    } catch (error) {
      console.error(`Error fetching upload details: ${error}`);
      store.dispatch(
        commonActions.showErrorAlert({
          type: 'error',
          delay: 4000,
          body: error,
          message: 'Something went wrong!',
        }),
      );
    }
  };
  const handleFetchSingleLicenseData = async () => {
    // Fetch the single license data based on the ID
    try {
      const { data } = await getLicenseDetails(id);
      if (data && !isEmpty(data)) {
        setSingleLicenseData(data);
      }
    } catch (error) {
      console.error(`Error fetching license details: ${error}`);
      store.dispatch(
        commonActions.showErrorAlert({
          type: 'error',
          delay: 4000,
          body: error,
          message: 'Something went wrong!',
        }),
      );
    }
  };

  useEffect(() => {
    if (!isEmpty(singleLicenseData)) {
      getSourceData(singleLicenseData.upload_id);
    }
  }, [singleLicenseData.upload_id]);

  useEffect(() => {
    if (!isEmpty(selectedRowData)) {
      setSingleLicenseData(selectedRowData);
      return;
    }
    if (id && isEmpty(singleLicenseData)) {
      handleFetchSingleLicenseData();
    }
  }, [id, selectedRowData]);

  return (
    <div>
      <Row>
        <Col md={4}>
          {CannabisLicenseHelper.LICENSE_DETAILS_LABLES_COL1.map(item => (
            <DataPreview
              key={item.id}
              label={item.LABEL}
              isLicenseDetails={item.id === 'lic-details'}
              data={singleLicenseData[item.id] || CannabisLicenseHelper.NO_VALUES}
              isAddress={item.id === 'address'}
              addressLineOne={
                item.id === 'address'
                  ? [
                      singleLicenseData['loc-street'],
                      singleLicenseData['loc-city'],
                      singleLicenseData['loc-state-code'],
                      singleLicenseData['loc-zip-code'],
                    ]
                      .filter(Boolean)
                      .join(', ')
                  : CannabisLicenseHelper.NO_VALUES
              }
              isDate={['updatedAt', 'lic-issue-date', 'lic-exp-date'].includes(item.id)}
            />
          ))}
        </Col>
        <Col md={4}>
          {CannabisLicenseHelper.LICENSE_DETAILS_LABLES_COL2.map(item => (
            <DataPreview
              key={item.id}
              label={item.LABEL}
              isLicenseDetails={item.id === 'lic-details'}
              data={singleLicenseData[item.id] || CannabisLicenseHelper.NO_VALUES}
              isAddress={item.id === 'address'}
              addressLineOne={
                item.id === 'address'
                  ? [
                      singleLicenseData['loc-street'],
                      singleLicenseData['loc-city'],
                      singleLicenseData['loc-state-code'],
                      singleLicenseData['loc-zip-code'],
                    ]
                      .filter(Boolean)
                      .join(', ')
                  : CannabisLicenseHelper.NO_VALUES
              }
              isDate={['updatedAt', 'lic-issue-date', 'lic-exp-date'].includes(item.id)}
            />
          ))}
        </Col>
        <Col md={4}>
          {CannabisLicenseHelper.LICENSE_DETAILS_LABLES_COL3.map(item => (
            <DataPreview
              key={item.id}
              label={item.LABEL}
              isLicenseDetails={item.id === 'lic-details'}
              data={singleLicenseData[item.id] || CannabisLicenseHelper.NO_VALUES}
              isAddress={item.id === 'address'}
              addressLineOne={
                item.id === 'address'
                  ? [
                      singleLicenseData['loc-street'],
                      singleLicenseData['loc-city'],
                      singleLicenseData['loc-state-code'],
                      singleLicenseData['loc-zip-code'],
                    ]
                      .filter(Boolean)
                      .join(', ')
                  : CannabisLicenseHelper.NO_VALUES
              }
              isDate={['updatedAt', 'lic-issue-date', 'lic-exp-date'].includes(item.id)}
            />
          ))}
          {optionalColumns.map(col => (
            <DataPreview
              key={col}
              label={CannabisLicenseHelper.LICENSE_DETAILS_OPTIONAL_LABLES[col] || col}
              data={singleLicenseData[col] || CannabisLicenseHelper.NO_VALUES}
            />
          ))}
        </Col>
      </Row>
    </div>
  );
}

export default DetailsView;
